// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var ApplicationSetting$ReactHooksTemplate = require("./applicationSetting.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var PaginationPolicyModes$ReactHooksTemplate = require("./PaginationPolicyModes.res.js");

var initialState_organization = OrganizationProfile$ReactHooksTemplate.empty();

var initialState = {
  edited: false,
  saving: false,
  organization: initialState_organization,
  notification: undefined
};

function SurveyPolicy(props) {
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.$$catch((function (error) {
                  return Promise.resolve((console.log(error), undefined));
                }), Js_promise.then_((function (json) {
                      return Promise.resolve(Curry._1(setState, (function (state) {
                                        return {
                                                edited: state.edited,
                                                saving: state.saving,
                                                organization: Json_decode.field("organization_profile", OrganizationProfile$ReactHooksTemplate.decode, json),
                                                notification: state.notification
                                              };
                                      })));
                    }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/organization_profiles/1")));
        }), []);
  var updateOrganizationSettings = function (e) {
    e.preventDefault();
    var organizationId = Belt_Option.getWithDefault(OrganizationProfile$ReactHooksTemplate.id(state.organization), 0);
    var params = {};
    params["organization_profile"] = OrganizationProfile$ReactHooksTemplate.encode(state.organization);
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("error", Json_decode.string, param);
                  }), response);
            var tmp;
            switch (status) {
              case "error" :
                  var errorMessage = Json_decode.field("error", Json_decode.string, response);
                  tmp = Curry._1(setState, (function (state) {
                          return {
                                  edited: state.edited,
                                  saving: state.saving,
                                  organization: state.organization,
                                  notification: {
                                    TAG: "Failure",
                                    _0: errorMessage
                                  }
                                };
                        }));
                  break;
              case "failure" :
                  tmp = Curry._1(setState, (function (state) {
                          return {
                                  edited: state.edited,
                                  saving: state.saving,
                                  organization: state.organization,
                                  notification: {
                                    TAG: "Failure",
                                    _0: "Invalid settings"
                                  }
                                };
                        }));
                  break;
              case "success" :
                  tmp = Curry._1(setState, (function (param) {
                          return {
                                  edited: false,
                                  saving: false,
                                  organization: Json_decode.field("organization_profile", OrganizationProfile$ReactHooksTemplate.decode, response),
                                  notification: {
                                    TAG: "Success",
                                    _0: "Survey policy updated successfully"
                                  }
                                };
                        }));
                  break;
              default:
                tmp = Curry._1(setState, (function (state) {
                        return {
                                edited: state.edited,
                                saving: state.saving,
                                organization: state.organization,
                                notification: {
                                  TAG: "Failure",
                                  _0: "Something went wrong. Please try\n          again later"
                                }
                              };
                      }));
            }
            return Promise.resolve(tmp);
          }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/organization_profiles/" + String(organizationId) + "/update", params));
  };
  var alertType = state.notification;
  return JsxRuntime.jsxs("div", {
              children: [
                alertType !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                              alertType: alertType,
                              handleClose: (function (param) {
                                  Curry._1(setState, (function (state) {
                                          return {
                                                  edited: state.edited,
                                                  saving: state.saving,
                                                  organization: state.organization,
                                                  notification: undefined
                                                };
                                        }));
                                })
                            }),
                        className: "max-w-7xl mx-auto px-6 sm:px-8 py-4"
                      }) : null,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("span", {
                                                                children: "📋",
                                                                className: "text-xl"
                                                              }),
                                                          className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                                        }),
                                                    JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("h1", {
                                                                children: "Survey Policy",
                                                                className: "text-2xl font-bold text-gray-900"
                                                              })
                                                        })
                                                  ],
                                                  className: "flex items-center space-x-3"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    state.edited ? JsxRuntime.jsx("span", {
                                                            children: "Unsaved changes",
                                                            className: "px-3 py-1.5 text-xs font-medium text-orange-700 bg-orange-50 rounded-full border border-orange-200"
                                                          }) : null,
                                                    JsxRuntime.jsx("button", {
                                                          children: state.saving ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                                  children: [
                                                                    JsxRuntime.jsx("span", {
                                                                          className: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
                                                                        }),
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "Saving..."
                                                                        })
                                                                  ]
                                                                }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                                  children: [
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "💾"
                                                                        }),
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "Save Changes"
                                                                        })
                                                                  ]
                                                                }),
                                                          className: (
                                                            state.edited && !state.saving ? "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-lg hover:shadow-xl" : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                          ) + " px-5 py-2.5 rounded-lg font-medium text-sm transition-all duration-200 disabled:cursor-not-allowed flex items-center space-x-2",
                                                          disabled: !state.edited || state.saving,
                                                          onClick: updateOrganizationSettings
                                                        })
                                                  ],
                                                  className: "flex items-center space-x-3"
                                                })
                                          ],
                                          className: "flex items-center justify-between"
                                        }),
                                    className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                                  }),
                              className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                            }),
                        JsxRuntime.jsx("div", {
                              children: $$Array.of_list(List.map((function (x) {
                                          var y = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
                                          if (y.TAG === "PaginationPolicies") {
                                            return JsxRuntime.jsx(PaginationPolicyModes$ReactHooksTemplate.make, {
                                                        setting: y._0,
                                                        enforce: ApplicationSetting$ReactHooksTemplate.enforce(x),
                                                        enforced: ApplicationSetting$ReactHooksTemplate.enforced(x),
                                                        onChange: (function (setting, enforce) {
                                                            var id = ApplicationSetting$ReactHooksTemplate.id(x);
                                                            var newApplicationSettings = List.map((function (x) {
                                                                    if (ApplicationSetting$ReactHooksTemplate.id(x) === id && !ApplicationSetting$ReactHooksTemplate.enforced(x)) {
                                                                      return ApplicationSetting$ReactHooksTemplate.setEnforce(enforce, ApplicationSetting$ReactHooksTemplate.setIndividualSetting(setting, x));
                                                                    } else {
                                                                      return x;
                                                                    }
                                                                  }), OrganizationProfile$ReactHooksTemplate.applicationSettings(state.organization));
                                                            Curry._1(setState, (function (state) {
                                                                    return {
                                                                            edited: true,
                                                                            saving: state.saving,
                                                                            organization: OrganizationProfile$ReactHooksTemplate.setApplicationSettings(state.organization, newApplicationSettings),
                                                                            notification: state.notification
                                                                          };
                                                                  }));
                                                          })
                                                      });
                                          } else {
                                            return JsxRuntime.jsx(JsxRuntime.Fragment, {});
                                          }
                                        }), OrganizationProfile$ReactHooksTemplate.applicationSettings(state.organization)))
                            })
                      ],
                      className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
                    })
              ],
              className: "h-full bg-gray-50"
            });
}

var make = SurveyPolicy;

exports.initialState = initialState;
exports.make = make;
/* initialState Not a pure module */
